export const request = 'REQUEST'
export const success = 'SUCCESS'
export const failure = 'FAILURE'
